import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ProjectBudgetOverviewReport } from '../../models/Financial/ProjectBudgetOverview';
import { FinancialService } from '../financial.service';

@Component({
    selector: 'app-project-budgets-overview',
    templateUrl: './project-budgets-overview.component.html',
    styleUrls: ['./project-budgets-overview.component.scss'],
})
export class ProjectBudgetsOverviewComponent implements OnInit, OnDestroy {
    report: ProjectBudgetOverviewReport;
    isLoading = true;
    private sub?: Subscription;

    constructor(private financialService: FinancialService) {}

    ngOnInit(): void {
        this.load();
    }

    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    load(): void {
        this.isLoading = true;
        this.sub = this.financialService.getProjectBudgetsByAccount().subscribe((report) => {
            this.report = report;
            this.isLoading = false;
        });
    }
}
